import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchTerm } from '../search-term'
import { SearchTermService } from '../search-term.service'
import { Observable }  from 'rxjs/Observable';
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { Topic } from '../topic'
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-search-term-box',
  templateUrl: './search-term-box.component.html',
  styleUrls: ['./search-term-box.component.css']
})
export class SearchTermBoxComponent implements OnInit {
  @Input() searchTerm: SearchTerm
  @Input() topic: Topic
  @Input() isEdit = false
  @Input() isShortDisplay = false
  @Input() isLongDisplay = false
  @Input() isSelectionDisplay = false

  private searchTermText = ''
  private submitSearchTermClicked = false
  private isDelete = false

  constructor(
    private router: Router,
    public rts: RuntimeService,
    private sts: SearchTermService,
    private ads: AdminService
  ) { }

  ngOnInit() {
    if (!this.searchTerm && this.sts.currentSearchTerm)
      this.searchTerm = this.sts.currentSearchTerm

    if (!this.searchTerm && this.rts.currentProject)
      this.searchTerm = this.sts.newSearchTerm()

    this.searchTermText = this.searchTerm.text
  }

  ngOnDestroy() {
    if (this.searchTerm && this.searchTerm.isNew)
      this.rts.currentProject.searchTermsMap.delete(this.searchTerm.id)
    this.sts.currentSearchTerm = null
  }

  switchEdit(runClear?: boolean) {
    if (runClear) {
      this.ads.clearSwitches()
      this.isEdit = false
    }

    if (this.isEdit)
      this.ngOnDestroy()
    else
      this.sts.currentSearchTerm = this.searchTerm

    this.isEdit = !this.isEdit
    this.ads.newSearchTermOn = this.isEdit
  }

  get hasSearchTermTextError() {
    if (!this.submitSearchTermClicked)
      return false
    return !this.searchTermText.length
  }

  switchDelete() {
    this.isDelete = !this.isDelete
  }

  confirmDelete() {
    let obs: Observable<any> = this.sts.delete(this.searchTerm)
    obs.subscribe((x) => null)
  }

  save() {
    this.submitSearchTermClicked = true
    if (this.hasSearchTermTextError)
      return
    this.searchTerm.text = this.searchTermText
    let obs: Observable<any> = this.sts.save(this.searchTerm)
    obs.subscribe((x) => {
        this.switchEdit()
    })
  }

  get topics() {
    return this.rts.currentProject.searchTermTopics(this.searchTerm)
  }

  isBound() {
    return this.rts.currentProject.isBound(this.topic, this.searchTerm)
  }

  associationSwitch() {
    this.rts.currentProject.bindTopicSearchTerm(this.topic, this.searchTerm)
  }

}



// WEBPACK FOOTER //
// ./src/app/search-term-box/search-term-box.component.ts